// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add_question,.space_box{margin-top:20px}.question-group{width:100%;height:260px;overflow:auto;border:1px solid #888;margin-top:15px}", ""]);
// Exports
module.exports = exports;
